module.exports = __webpack_public_path__ + "static/media/-ve3.46333c1f.png";